import { Container, BoxCotent1 } from "./style";

const OurImpact = () => {
  return (
    <Container>
      <h1>Our Impact</h1>
      <BoxCotent1>
        <div>
          <h6>TREE PLANTING</h6>
          <h5>
            124,834{" "}
            <span>
              Trees <br /> Planted
            </span>
          </h5>
          <p>
            Associate with planting projects - we help replant tree at
            deforestation areas.
          </p>
        </div>
        <div>
          <h6>FOREST RESTORATION</h6>
          <h5>
            46+
            <span>
              Hectares
              <br />
              Restored
            </span>
          </h5>
          <p>
            We work with high-impact reforestation project across the globe.
          </p>
        </div>
      </BoxCotent1>
      <BoxCotent1 reverse={true}>
        <div>
          <h6>VOLUNTEER</h6>
          <h5>
            11.000
            <span>
              People <br /> Involved
            </span>
          </h5>
          <p>
            We unite group with thousands of people with the same goal to heal
            the earth
          </p>
        </div>
        <div>
          <h6>METHODOLOGIES UNDER DEVELOPMENT</h6>
          <h5>40+</h5>
          <p>Our innovative methodologies measure improvements</p>
        </div>
      </BoxCotent1>
    </Container>
  );
};
export default OurImpact;
